var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prize-draw-results mb-3"},[_c('b-link',{staticClass:"w-100 btn btn-success",attrs:{"to":"/savings/prize-saver/draws"}},[_vm._v(" We are pleased to announce the winners for the "+_vm._s(_vm.latestDrawDate)+" PrizeSaver draw! ... [Read More] ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }